import React from 'react';
import { registerDecoration } from 'core/forms';

const FormDecorationFakeValue = () => (null);

registerDecoration('FakeValue', React.memo(FormDecorationFakeValue));

export default FormDecorationFakeValue;
